<template>
  <li
    v-if="canViewVerticalNavMenuLink(item) && canView(item)"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <!--<feather-icon
        v-if="!item.hideIcon"
        v-bind="itemIcon(item)"
      />-->
      <svg
        v-if="!item.hideIcon && item.svgIcon"
        width="15px"
        height="15px"
        :fill="isActive ? 'white' : '#5e5873'"
        :style="{height:'15px' , width: '15px'}"
      >
        <use :xlink:href="svgUrl" />
      </svg>
      <span class="menu-title text-truncate">{{ item.title && typeof item.title === 'function' ? t(item.title()) : t(item.title) }}</span>
      <b-badge
        v-if="hasTag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto tag-badge"
      >
        {{ $t('nav_tags.'+item.tag) }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'
import NavigationPermissionMixin from '@/mixins/navigation-permission-mixin'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink, NavigationPermissionMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasTag() {
      if (!this.item.tag) return false
      if (this.item.tagPackagePermission && this.item.tag === 'upgrade') {
        const permissions = Array.isArray(this.item.tagPackagePermission) ? this.item.tagPackagePermission : [this.item.tagPackagePermission]
        let hasTag = true
        permissions.forEach(permission => {
          if (this.$store.getters['subscription/canAccessFeature'](permission))hasTag = false
        })
        return hasTag
      }
      return true
    },
    svgUrl() {
      if (!window.spriteUrl) {
        // eslint-disable-next-line global-require
        window.spriteUrl = require('@/assets/images/icons/sprite.svg')
      }
      return `${window.spriteUrl}#${this.item.svgIcon}`
    },

  },
  setup(props) {
    const {
      isActive, linkProps, updateIsActive,
    } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },

  methods: {
    itemIcon(item) {
      let icon = 'CircleIcon'; const
        className = ''

      if (item.icon) {
        icon = item.icon
      }

      if (item.wizard && this.$store.getters['setup/isWizardPassed'](item.wizard)) {
        icon = 'CheckIcon'
      }
      return {
        icon,
        class: className,
      }
    },

  },
}
</script>
<style scoped>
.tag-badge{
  font-size: 8px;
  position: absolute;
  right: 0;
  top: 0;
  background-color: transparent;
  color: red;
}
</style>
